/**
 * 货品标签 表单配置处理
 * @author zjs
 * @time 2017-12-11
 */
export default {
    data () {
        return {
            formConfig: [{
                name: "所属分类",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '轮胎类'
                    }, {
                        value: '2',
                        label: '汽配类'
                    }, {
                        value: '3',
                        label: '礼品/其他类'
                    }, {
                        value: '4',
                        label: '服务/劳务/虚拟类'
                    }]
                },
                field: "fenlei_id",
                default: '1'
            }, {
                name: "标签分类",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '标签'
                    }, {
                        value: '2',
                        label: '标签2'
                    }, {
                        value: '3',
                        label: '标签3'
                    }, {
                        value: '4',
                        label: '标签4'
                    }]
                },
                field: "batch_id",
                default: '1'
            },{
                name: "标签名称",
                type: "ElInput",
                field: "name"
            }]
        }
    }
}